import API from "serviceshift-ui/api-client";

export default {
  fetchMembershipPrograms({ commit }, activeOnly = false) {
    return API.membershipProgram.getAll(activeOnly).then((res) => {
      commit("replace", {
        state: "membershipPrograms",
        data: res.data
      });
    });
  },
  fetchMembershipProgram({ commit }, id) {
    return API.membershipProgram.get(id).then((res) => {
      commit("replace", {
        state: "currentMembershipProgram",
        data: res.data
      });
    });
  },
  clearCurrentMembershipProgram({ commit }) {
    commit("replace", {
      state: "currentMembershipProgram",
      data: null
    });
  }
};
